(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[585],{

/***/ 8729:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[id]",
      function () {
        return __webpack_require__(7091);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1797);
/* harmony import */ var _components_navbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9106);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4898);






function JobPage(param) {
    var job = param.job;
    var employmentType = job.title.toLowerCase().includes("contract") ? "Contract" : "Full-Time";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: job.title,
                name: "Watershed Jobs",
                description: "Interested in joining Watershed? Learn about this ".concat(job.department.toLowerCase(), " role & others we\u2019re hiring for."),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org/",
                            "@type": "JobPosting",
                            title: job.title,
                            employmentType: employmentType,
                            jobLocation: job.location,
                            description: "See more about this ".concat(job.department, " role on watershed.com."),
                            employmentUnit: job.department,
                            url: "https://watershed.com/jobs/".concat(job.slug),
                            applicationContact: {
                                "@type": "ContactPoint",
                                email: "recruiting@watershed.com"
                            },
                            hiringOrganization: {
                                "@type": "Organization",
                                name: "Watershed",
                                url: "https://watershed.com",
                                logo: {
                                    "@type": "ImageObject",
                                    url: "https://watershed.com/favicon.svg"
                                }
                            }
                        })
                    },
                    className: "jsx-ffe4c88380f5ddde"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navbar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "jsx-ffe4c88380f5ddde",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
                        className: "jsx-ffe4c88380f5ddde",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/jobs",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    style: {
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    className: "jsx-ffe4c88380f5ddde",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            width: "14",
                                            height: "13",
                                            viewBox: "0 0 14 13",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "aria-hidden": true,
                                            className: "jsx-ffe4c88380f5ddde",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M1 4H8.5C10.7091 4 12.5 5.79086 12.5 8V8C12.5 10.2091 10.7091 12 8.5 12H5M1 4L4.5 1.5M1 4L4.5 7",
                                                stroke: "#265CFF",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                className: "jsx-ffe4c88380f5ddde"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            style: {
                                                marginLeft: 12
                                            },
                                            className: "jsx-ffe4c88380f5ddde",
                                            children: "All open roles"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-ffe4c88380f5ddde",
                                children: job.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                                className: "jsx-ffe4c88380f5ddde",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-ffe4c88380f5ddde",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                className: "jsx-ffe4c88380f5ddde",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                                className: "jsx-ffe4c88380f5ddde",
                                                children: job.location.toString().replace(", United States", "")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-ffe4c88380f5ddde",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                className: "jsx-ffe4c88380f5ddde",
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                                className: "jsx-ffe4c88380f5ddde",
                                                children: employmentType
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-ffe4c88380f5ddde",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                className: "jsx-ffe4c88380f5ddde",
                                                children: "Department"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                                className: "jsx-ffe4c88380f5ddde",
                                                children: job.department
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: job.greenhouseUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "jsx-ffe4c88380f5ddde" + " " + "button primary",
                                children: "Apply now"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                        className: "jsx-ffe4c88380f5ddde" + " " + "blog-post",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: job.content
                            },
                            className: "jsx-ffe4c88380f5ddde"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: job.greenhouseUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        style: {
                            width: "fit-content"
                        },
                        className: "jsx-ffe4c88380f5ddde" + " " + "button primary mobile-only",
                        children: "Apply now"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "ffe4c88380f5ddde",
                children: "main.jsx-ffe4c88380f5ddde{display:grid;-webkit-column-gap:32px;-moz-column-gap:32px;column-gap:32px;row-gap:48px;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start}h1.jsx-ffe4c88380f5ddde{margin:0;line-height:1.125}aside.jsx-ffe4c88380f5ddde{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:16px}dl.jsx-ffe4c88380f5ddde{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px;margin-bottom:16px;color:#494e5a}dt.jsx-ffe4c88380f5ddde{font-weight:bold}article.blog-post.jsx-ffe4c88380f5ddde{border:0;padding:0;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}article.blog-post.jsx-ffe4c88380f5ddde div:first-child h2:first-child{margin-top:0}@media(min-width:820px){main.jsx-ffe4c88380f5ddde{grid-template-columns:1fr 2fr;padding:48px 12px}aside.jsx-ffe4c88380f5ddde{position:-webkit-sticky;position:sticky;top:108px}article.blog-post.jsx-ffe4c88380f5ddde{padding-top:48px}article.blog-post.jsx-ffe4c88380f5ddde h2{font-size:24px}.mobile-only.jsx-ffe4c88380f5ddde{display:none}}@media(min-width:1100px){main.jsx-ffe4c88380f5ddde{gap:64px}}"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (JobPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [109,854,774,888,179], function() { return __webpack_exec__(8729); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);